import { getUserRoles } from 'utils/localStorage';

const hasPermission = (roles) => {
  const userRoles = getUserRoles()?.split(',');

  return userRoles?.some((userRole) => roles.includes(userRole));
};

export default hasPermission;
